/* mo-bd.js: sheets and bedding page (sections/mo-bd-main.liquid), Mattress Overstock 2026-10-14.
   - One size picker reprices both sets from their live variants. Sizes map across naming schemes:
     "Twin/Twin XL" covers Twin and Twin XL, "King/Cal King" covers King and Cal King.
   - Color swatches swap to the store's photo of that color and carry the variant into the link.
   - "Will it stay on?" mounts assets/mo-bd-pocket.js when it nears the screen, with each set's published
     pocket limit. The cloth takes the chosen Purple color. Verdicts are plain arithmetic on the two limits.
   No DOM writes inside a repaint; the only observers are an IntersectionObserver and one on <html>'s scheme. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bd]');
  if (!root) return;

  var POCKET = { purple: 15.5, tempur: 13 };
  var CLOTH = { purple: '#f1f1f2', tempur: '#f4f3f0' };
  var state = { size: root.getAttribute('data-size') || 'Queen' };

  function money(c) {
    var d = c / 100;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function covers(value, size) {
    if (!value) return false;
    return String(value).replace('California King', 'Cal King').split('/').some(function (p) { return p.trim() === size; });
  }
  function fmt(x) { return (Math.round(x * 2) / 2).toString(); }

  /* ---------------- compare cards ---------------- */
  var cards = [].slice.call(root.querySelectorAll('[data-bd-card]')).map(function (el) {
    var data = [];
    try { data = JSON.parse(el.querySelector('[data-bd-variants]').textContent); } catch (e) {}
    var c = { el: el, v: data, so: +el.getAttribute('data-size-opt') - 1, co: +el.getAttribute('data-color-opt') - 1, color: null, handle: el.getAttribute('data-handle') };
    var on = el.querySelector('.bd-swatch[aria-pressed="true"]');
    if (on) c.color = on.getAttribute('data-bd-color');
    return c;
  });

  function pick(c) {
    var m = c.v.filter(function (v) { return covers(v.o[c.so], state.size) && (c.co < 0 || !c.color || v.o[c.co] === c.color); });
    if (!m.length && c.co >= 0) m = c.v.filter(function (v) { return covers(v.o[c.so], state.size); });
    return m;
  }

  function render(c) {
    var m = pick(c), el = c.el;
    var price = el.querySelector('[data-bd-price]'), sz = el.querySelector('[data-bd-price-size]');
    var href = el.querySelector('[data-bd-link]').getAttribute('href').split('?')[0];
    if (!m.length) {
      price.textContent = 'Not made in ' + state.size; price.classList.add('is-none'); sz.textContent = '';
    } else {
      var lo = Math.min.apply(null, m.map(function (v) { return v.p; })), hi = Math.max.apply(null, m.map(function (v) { return v.p; }));
      price.textContent = (hi > lo ? 'From ' : '') + money(lo); price.classList.remove('is-none');
      sz.textContent = state.size + ' set';
      var best = m.filter(function (v) { return v.a; })[0] || m[0];
      href += '?variant=' + best.id;
    }
    el.querySelectorAll('[data-bd-link]').forEach(function (a) { a.setAttribute('href', href); });
    return m.length ? money(Math.min.apply(null, m.map(function (v) { return v.p; }))) : 'not made in this size';
  }

  var live = root.querySelector('[data-bd-live]');
  function renderAll(announce) {
    var parts = cards.map(function (c) {
      var brand = (c.el.querySelector('.bd-card__brand') || {}).textContent || '';
      return brand.trim() + ' ' + render(c);
    });
    if (announce && live) live.textContent = state.size + ': ' + parts.join(', ') + '.';
  }

  root.querySelectorAll('[data-bd-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.size = b.getAttribute('data-bd-size');
      root.querySelectorAll('[data-bd-size]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      renderAll(true);
    });
  });

  cards.forEach(function (c) {
    c.el.querySelectorAll('.bd-swatch').forEach(function (b) {
      b.addEventListener('click', function () {
        c.color = b.getAttribute('data-bd-color');
        c.el.querySelectorAll('.bd-swatch').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var name = c.el.querySelector('[data-bd-colorname]'); if (name) name.textContent = c.color;
        var img = c.el.querySelector('[data-bd-img]'), src = b.getAttribute('data-photo');
        if (img && src) {
          img.classList.add('is-swap');
          var pre = new Image();
          pre.onload = pre.onerror = function () { img.removeAttribute('srcset'); img.src = src; img.classList.remove('is-swap'); };
          pre.src = src;
        }
        if (/purple/.test(c.handle)) { CLOTH.purple = b.getAttribute('data-cloth') || CLOTH.purple; if (fit.api) fit.api.setColor(CLOTH.purple, 'purple'); }
        render(c);
      });
    });
  });
  renderAll(false);

  // sources: open on wide screens, folded on phones (far below the first screen); a footnote mark opens it
  var notes = root.querySelector('[data-bd-notes]');
  if (notes) {
    if (window.matchMedia('(max-width: 699px)').matches) notes.open = false;
    root.querySelectorAll('.bd-sup').forEach(function (a) { a.addEventListener('click', function () { notes.open = true; }); });
  }

  // phones show fabric and pocket first; one button opens the rest on both cards
  var more = root.querySelector('[data-bd-more]');
  if (more) {
    root.classList.add('is-js');
    more.hidden = false;
    more.addEventListener('click', function () {
      var open = more.getAttribute('aria-expanded') !== 'true';
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-more', open);
      more.textContent = open ? 'Show less' : 'Show band, care and sizes';
    });
  }

  /* ---------------- Will it stay on? ---------------- */
  var fit = { el: root.querySelector('[data-bd-fit]'), api: null, sheet: 'purple', h: 12 };
  if (!fit.el) return;
  var range = fit.el.querySelector('[data-bd-h]'), out = fit.el.querySelector('[data-bd-hout]'), say = fit.el.querySelector('[data-bd-say]');
  var cv = fit.el.querySelector('[data-bd-cv]');
  fit.h = parseFloat(range.value) || 12;
  var startPick = fit.el.querySelector('.bd-pick[aria-pressed="true"]');
  if (startPick) { fit.h = parseFloat(startPick.getAttribute('data-bd-pick')); range.value = fit.h; }

  function verdicts() {
    var h = fit.h, txt;
    ['purple', 'tempur'].forEach(function (k) {
      var v = fit.el.querySelector('[data-bd-verdict="' + k + '"]'), spare = POCKET[k] - h;
      v.textContent = spare >= 0 ? 'Stays on' : 'Rides up';
      v.classList.toggle('is-off', spare < 0);
    });
    var sp = POCKET.purple - h, st = POCKET.tempur - h;
    function spare(x) { return x === 0 ? 'right at its limit' : fmt(x) + ' in. to spare'; }
    if (st >= 0) txt = 'At ' + fmt(h) + ' in. both pockets reach under the mattress. Purple has ' + spare(sp) + ', Tempur-Pedic ' + spare(st) + '.';
    else if (sp >= 0) txt = 'At ' + fmt(h) + ' in. Purple\'s Standard pocket reaches under with ' + spare(sp) + '. Tempur-Pedic\'s 13 in. pocket is ' + fmt(-st) + ' in. short, so its corners ride up.';
    else txt = 'At ' + fmt(h) + ' in. both pockets are short: Purple\'s Standard by ' + fmt(-sp) + ' in., Tempur-Pedic\'s by ' + fmt(-st) + ' in. Purple also makes a Deep Pocket SoftStretch for 16 to 20 in. mattresses (see note a).';
    say.textContent = txt;
    out.textContent = fmt(h) + ' in.';
    range.setAttribute('aria-valuetext', fmt(h) + ' inches');
    fit.el.querySelectorAll('[data-bd-pick]').forEach(function (b) { b.setAttribute('aria-pressed', Math.abs(parseFloat(b.getAttribute('data-bd-pick')) - h) < 0.01 && b === fit.lastPick ? 'true' : 'false'); });
  }
  fit.lastPick = startPick;

  function setH(h, fromPick) {
    fit.h = h; fit.lastPick = fromPick || null;
    verdicts();
    if (fit.api) fit.api.setHeight(h);
  }
  range.addEventListener('input', function () { setH(parseFloat(range.value)); });
  fit.el.querySelectorAll('[data-bd-pick]').forEach(function (b) {
    b.addEventListener('click', function () { var h = parseFloat(b.getAttribute('data-bd-pick')); range.value = h; setH(h, b); });
  });
  fit.el.querySelectorAll('[data-bd-sheet]').forEach(function (b) {
    b.addEventListener('click', function () {
      fit.sheet = b.getAttribute('data-bd-sheet');
      fit.el.querySelectorAll('[data-bd-sheet]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (fit.api) fit.api.setSheet(fit.sheet);
    });
  });
  verdicts();

  function hexOf(css) {
    var m = String(css).match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!m) return css && css[0] === '#' ? css : '#1d1b19';
    return '#' + [m[1], m[2], m[3]].map(function (x) { return (+x).toString(16).padStart(2, '0'); }).join('');
  }
  function isDark() { return document.documentElement.getAttribute('data-mo-scheme') === 'dark'; }
  function stageBg() { return hexOf(getComputedStyle(fit.el.querySelector('.bd-fit__card')).backgroundColor); }

  function mount() {
    if (fit.api || !window.MOBdPocket || !cv) return;
    fit.api = window.MOBdPocket.mount(cv, {
      dark: true, bg: stageBg(), height: fit.h, sheet: fit.sheet,
      sheets: { purple: { pocket: POCKET.purple, color: CLOTH.purple }, tempur: { pocket: POCKET.tempur, color: CLOTH.tempur } },
      label: function (h) { return { height: h + ' in.' }; }
    });
    requestAnimationFrame(function () { cv.classList.add('is-live'); });
    // one moment on first view: the hem pulls under the edge with a small snap
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && POCKET[fit.sheet] >= fit.h) fit.api.snap();
    new MutationObserver(function () { fit.api.setDark(true, stageBg()); }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-mo-scheme'] });
  }
  function whenReady() {
    if (window.MOBdPocket) return mount();
    var t = setInterval(function () { if (window.MOBdPocket) { clearInterval(t); mount(); } }, 120);
    setTimeout(function () { clearInterval(t); }, 10000);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); whenReady(); } }, { rootMargin: '300px 0px' });
    io.observe(fit.el);
  } else whenReady();
})();
